import request from './request.js'

export default{

  //==============  softwareInfo.vue 软件信息  ===============

    //查询软件编号是否存在
    ExistsSoftwareId(params){
      // 拼接参数： softwareId 软件编号  （返回布尔值）
      return request({
        url: '/Software/ExistsSoftwareId' + params,
        method: 'get'
      });
    },

    //单个添加软件信息
    addSoftwareInfoSingle(params) {
      //对象传参：id 软件编号、name 软件名称 、englishName 英文名称 、description 软件描述
      return request({
        url: '/Software/Set',
        method: 'post',
        data: params
      });
    },
    //单个修改软件信息
    setSoftwareInfoSingle(params) {
      //对象传参： 软件信息DTO（查询的所有信息）
      return request({
        url: '/Software/Set',
        method: 'post',
        data: params
      });
    },
    //查询所有软件信息
    getSoftwareInfoAll(){
      return request({
        url: '/Software/GetAll',   // code: 200 success
        method: 'get'
      });
    },

    //==============  versionType.vue 版本类型  ===============

    //单个添加版本类型
    addVersiontypeSingle(params) {
      //软件版本类型DTO
      return request({
        url: '/Software/SetVersionType',
        method: 'post',
        data: params
      });
    },
    //单个修改版本类型
    setVersiontypeSingle(params) {
      //对象传参： 软件版本类型DTO（查询的所有信息）
      return request({
        url: '/Software/SetVersionType',
        method: 'post',
        data: params
      });
    },
    //查询所有版本类型
    getVersiontypeAll(){
      return request({
        url: '/Software/GetAllVersionType',   // code: 200 success
        method: 'get'
      });
    },
		// 获取穿透使用【软件版本信息】
		getAllFrpSoftwareVersion() {
			return request({
				url:'/Software/GetAllFrpSoftwareVersion',
				method:'get'
			});
		},
		// 删除版本类型
		deleteVersionType(params) {
			return request({
				url:'/Software/DeleteVersionType' + params,
				method:'post'
			})
		},

    //==============  versionInfo.vue 软件版本信息  ===============

    //单个添加软件版本
    addSoftwareVerSingle(params) {     //(参数一： versionDTO 字符串 表单信息；参数二：对象 文件 )
       //软件版本DTO集合
      return request({
				url: '/Software/SetVersion',
        // url: '/Software/Release',
        method: 'post',
        data: params
      });
    },
    //查询所有软件版本信息（查询所有可不传参）
    getSoftwareVerAll(params){
      //拼接传参：softwareId - 软件版本信息编号 version - 软件版本号  int versionTypeId - 软件版本类型编号 isDesc  时间倒叙查询 布尔值
      return request({
				url: '/Software/PaginatedSoftwareVersion' + params,   // code: 200 success
        // url: '/Software/GetAllSoftwareVersion' + params,   // code: 200 success
        method: 'get'
      });
    },
		//查询所有软件版本信息（查询所有可不传参）
		getAllSoftwareVer(params){
		  //拼接传参：softwareId - 软件版本信息编号 version - 软件版本号  int versionTypeId - 软件版本类型编号 isDesc  时间倒叙查询 布尔值
		  return request({
		    url: '/Software/GetAllFrpSoftwareVersion' + params,   // code: 200 success
		    method: 'get'
		  });
		},
		// 删除单行软件信息
		deleteSoftwareInformation(params) {
			return request({
				url:'/Software/Delete'+params,
				method:'post'
			})
		}
}
